import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import TestContentApp from "./TestContent";
import AccomplishmentsPage from "./components/Accomplishments";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Check for test content parameter
const urlParams = new URLSearchParams(window.location.search);
const showTestContent = urlParams.get("test") === "content";
const showAccomplishments = urlParams.get("page") === "accomplishments";

if (showTestContent) {
  root.render(
    <React.StrictMode>
      <TestContentApp />
    </React.StrictMode>
  );
} else if (showAccomplishments) {
  root.render(
    <React.StrictMode>
      <AccomplishmentsPage />
    </React.StrictMode>
  );
} else {
  // Default: render main app
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
